import { useRepository } from 'hooks/auth'
import { useRootStore } from 'hooks/rootStore'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { InfoFilledIcon } from './icons/InfoFilled'

export const ImpersonationBar = observer(function ImpersonationBar() {
  const { t } = useTranslation()
  const repository = useRepository()
  const rootStore = useRootStore()

  const userId = rootStore.impersonationInfo?.userId
  const hideBanner = rootStore.impersonationInfo?.hideBanner ?? false

  // Not impersonating
  if (!userId || hideBanner) return null

  const instructorUser = repository.userStore.getUser(userId)

  return (
    <div
      className={classNames(
        'flex flex-row items-center justify-between bg-fixed-accent-color p-4 text-label-medium',
        {}
      )}
    >
      <div className="flex flex-row items-center gap-2">
        <InfoFilledIcon className="fill-core-primary stroke-fixed-accent-color" />
        {t('instructor_classes.impersonating', {
          instructor: instructorUser.fullName,
        })}
      </div>
      <button
        onClick={() => {
          rootStore.stopImpersonation()
        }}
        className="hover:underline"
      >
        {t('instructor_classes.stop_impersonating')}{' '}
      </button>
    </div>
  )
})
